module.exports = __webpack_public_path__ + "static/media/Artichauts.1914cfa9.svg";